// extracted by mini-css-extract-plugin
module.exports = {"brands":"Brands-styles-module--brands--2qXKt"};